import React, { useState, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useToast } from './hooks/useToast';
import { useAuth } from './hooks/useAuth';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import LoadingSpinner from './components/common/LoadingSpinner';
import ErrorBoundary from './components/common/ErrorBoundary';
import ToastContainer from './components/common/ToastContainer';
import LoginModal from './components/auth/LoginModal';

// Lazy load components
const HomePage = React.lazy(() => import('./components/layout/HomePage'));
const ProviderSearch = React.lazy(() => import('./components/providers/ProviderSearch'));
const CountryHealthcare = React.lazy(() => import('./components/directory/CountryHealthcare'));
const AboutUsSection = React.lazy(() => import('./components/layout/HomePage/sections/AboutUsSection'));

export default function App() {
  const [activeTab, setActiveTab] = useState<'home' | 'providers' | 'global' | 'about'>('home');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { toasts, removeToast } = useToast();
  const { user, signOut } = useAuth();

  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header
            activeTab={activeTab}
            onTabChange={setActiveTab}
            user={user}
            onSignOut={signOut}
            onSignInClick={() => setShowLoginModal(true)}
          />

          <main className="flex-grow">
            <Suspense fallback={<LoadingSpinner size="lg" message="Loading content..." />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/providers" element={<ProviderSearch />} />
                <Route path="/global" element={<CountryHealthcare />} />
                <Route path="/about" element={<AboutUsSection />} />
              </Routes>
            </Suspense>
          </main>

          <Footer />

          <ToastContainer toasts={toasts} onClose={removeToast} />

          {showLoginModal && (
            <LoginModal onClose={() => setShowLoginModal(false)} />
          )}
        </div>
      </Router>
    </ErrorBoundary>
  );
}
